import apiClient from 'API/client';
import { API_ENDPOINTS } from 'API/endpoints';
import UI_MESSAGES from 'i18n/messages';

export const fetchGetUserData = async (userId) => {
  try {
    const params = {};
    params.userId = userId;

    const response = await apiClient.get(API_ENDPOINTS.USER.GET, {
      params
    });

    if (response.status !== 200) {
      throw new Error(UI_MESSAGES.common.statusError('obtener datos de usuario', response.status));
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error(UI_MESSAGES.logs.apiResponseError + ':', error.response.data);
    } else if (error.request) {
      console.error(UI_MESSAGES.logs.apiNetworkError + ':', error.request);
    } else {
      console.error(UI_MESSAGES.logs.apiGenericError + ':', error.message);
    }
    throw error;
  }
};

export default fetchGetUserData;
